export const h = {
  navMenu: ["메인","보상", "캐릭터", "게임 특징"],
  }


// WEBPACK FOOTER //
// ./src/i18n/lan/kr.js